import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { useClientConfigCtx } from '../hooks/useClientConfigCtx';
import { Create } from './Claim';

// Clients whose claim creation has moved to another portal hide the create-claim button, but the
// route would still be reachable from a bookmark or browser history. Send those back to the hub,
// where the notice explains where to go instead.
const CreateClaimRoute: React.FC = () => {
	const { config } = useClientConfigCtx();
	const claimCreationMoved = !!config.ui?.hideCreateClaim && !!config.ui?.createClaimRedirectUrl;

	return claimCreationMoved ? <Navigate to="/hub" replace /> : <Create />;
};

export { CreateClaimRoute };
